var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.56299 7.84942L1.01342 8.99501L0.879701 9.0235C0.677282 9.07974 0.49275 9.1912 0.34495 9.34649C0.19715 9.50179 0.091378 9.69536 0.0384347 9.90743C-0.0145086 10.1195 -0.012726 10.3425 0.0436004 10.5536C0.0999268 10.7647 0.208779 10.9564 0.359041 11.1091L5.82834 16.681L4.53852 24.5515L4.52314 24.6877C4.51075 24.9069 4.55422 25.1255 4.64911 25.3212C4.74399 25.517 4.88688 25.6828 5.06313 25.8018C5.23939 25.9207 5.44269 25.9885 5.6522 25.9982C5.86172 26.0079 6.06993 25.9591 6.25552 25.8569L13.0075 22.1414L19.7442 25.8569L19.8625 25.9138C20.0578 25.9944 20.2701 26.019 20.4775 25.9854C20.685 25.9517 20.8801 25.8609 21.043 25.7222C21.2058 25.5835 21.3305 25.402 21.4042 25.1963C21.4779 24.9906 21.498 24.768 21.4624 24.5515L20.1714 16.681L25.643 11.1079L25.7353 11.0026C25.8672 10.8326 25.9536 10.6291 25.9859 10.4128C26.0181 10.1965 25.995 9.97512 25.9188 9.7712C25.8427 9.56729 25.7163 9.38814 25.5525 9.25201C25.3887 9.11588 25.1933 9.02763 24.9863 8.99625L17.4367 7.84942L14.0619 0.691032C13.9642 0.48363 13.813 0.30898 13.6255 0.186854C13.4379 0.0647269 13.2214 0 13.0004 0C12.7795 0 12.563 0.0647269 12.3754 0.186854C12.1878 0.30898 12.0367 0.48363 11.939 0.691032L8.56299 7.84942Z",
    fill: "#FFB84D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopular);
export default __webpack_public_path__ + "static/media/Popular.33d7c539a1bac5806131a66e23f53dae.svg";
export { ForwardRef as ReactComponent };